// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"298":"43cbd0662c8c8cbc","365":"1e14769039f6e3d9","663":"db329eec5dd58820","821":"87b492c0f81d54e3"}[chunkId] + ".js";
};